import React, { FunctionComponent, ReactElement, ReactNode } from "react";
import "./style.scss";

export interface Logo {
  name: string;
  src: string;
}

interface Props {
  children: ReactNode;
  logos?: Logo[];
  price?: string;
  title: string;
}

const CartRadioInputLabelInfos: FunctionComponent<Props> = ({
  children,
  title,
  price,
  logos = [],
}): ReactElement => {
  return (
    <div className="CartRadioInputLabelInfos">
      <div className="CartRadioInputLabelInfos-description">
        <div className="CartRadioInputLabelInfos-description-title">
          {title}
          <span>
            {logos &&
              logos.map(({ src, name }, i) => (
                <img
                  key={`CartRadioInputLabelInfosDdescriptionTitleLogo_${src}_${i}`}
                  className="CartRadioInputLabelInfos-description-title-logo"
                  alt={name}
                  src={src}
                />
              ))}
          </span>
        </div>
        <div className="CartRadioInputLabelInfos-description-detailed">{children}</div>
      </div>
      {price && <div className="CartRadioInputLabelInfos-price">{price}</div>}
    </div>
  );
};

export default React.memo(CartRadioInputLabelInfos);
